const optionTrack = [
	{
		value: "Academic Track",
		options: [
			{ abbr: "ABM", strand: "ABM (Accountancy, Business, and Management)" },
			{ abbr: "GAS", strand: "GAS (General Academic Strand)" },
			{ abbr: "HUMSS", strand: "HUMSS (Humanities and Social Sciences)" },
			{
				abbr: "STEM",
				strand: "STEM (Science, Technology, Engineering, and Mathematics)",
			},
		],
	},
	{
		value: "Arts and Design Track",
		options: [{ abbr: "AF", strand: "AF (Arts and Design)" }],
	},
	{
		value: "Sports Track",
		options: [{ abbr: "Sports", strand: "Sports" }],
	},
	{
		value: "Technical-Vocational-Livelihood (TVL) Track",
		options: [
			{ abbr: "AFA", strand: "AFA (Agricultural-Fishery Arts)" },
			{ abbr: "HE", strand: "HE (Home Economics)" },
			{ abbr: "IA", strand: "IA (Industrial Arts)" },
			{
				abbr: "ICT",
				strand: "ICT (Information and Communications Technology)",
			},
		],
	},
];

export default optionTrack;
